import {
  convertTreeDataToArray,
  validateEmail,
} from "@/common/function/ArrayFunction";
import {
  ICategorizationInfo,
  ITreeInfo,
} from "@/components/ui/TreeSelect/Models";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import {
  baContainer,
  IAppointmentManager,
  IAuthenticationService,
  OutlookAppointmentRecurrenceDto,
  TokenIAppointmentManager,
  TokenIAuthenticationService,
  TreeTypeEnum,
} from "@/index";
import { DateTimePeriodDto } from "@/out-look/dto/DateTimePeriodDto";
import {
  IOutlookAppointmentService,
  TokenIOutlookAppointmentService,
} from "@/out-look/services";
import {
  ICategorization,
  OrganizationInfo,
  Organizer,
} from "@/services/organization-service/entity/OrganizationEntity";
import {
  DateTimePeriod,
  OutLookInfo,
} from "@/services/organization-service/entity/OutLookEntity";
import {
  IOrganizationService,
  OrganizationService,
  TokenIOrganizationService,
} from "@/services/organization-service/index";
import { ROOT } from "@/services/resource-service/entity/Enums";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { IOrganizationStore } from "./OrganizationModel";

const initialState: IOrganizationStore = {
  orgInfo: null,
  loading: true,
  locationTrees: null,
  locationList: null,
  categoryTrees: null,
  outlookInfo: null,
  organizer: null,
};

export const getOrgInfo: any = createAsyncThunk(
  "organization/get-info",
  async (
    request: { outlookUid: string; isReOpen?: boolean; isRecurringMaster?: boolean },
    { rejectWithValue }
  ) => {
    console.log("getOrgInfo", request);
    
    const orgServiceImpl: IOrganizationService = new OrganizationService();
    const response: HttpResponse<OrganizationInfo> =
      await orgServiceImpl.fetchOrgInfo();
    response.data.uidOutlook = request.outlookUid;
    if (!response.error) {
      const olOrganizerService: IOrganizationService = baContainer.resolve(
        TokenIOrganizationService
      );
      const organizer = await olOrganizerService.GetCurrentOrganizer();
      if (window.axiosInstance.defaults.headers) {
        window.axiosInstance.defaults.headers.common["timezone"] =
          organizer?.TimeZoneStandardName;
      }
      if (!response.data.isExternal) {
        const olAppointmentService: IOutlookAppointmentService =
          baContainer.resolve(TokenIOutlookAppointmentService);
        const authenticationService: IAuthenticationService =
          baContainer.resolve(TokenIAuthenticationService);
        const getMessageUrl = olAppointmentService.GetMessageUrl();
        const accessToken = await authenticationService.GetCallbackToken();
        const respiCalUId = await orgServiceImpl.getAppInfoByItemId(
          getMessageUrl,
          accessToken
        );

        response.data.iCalUId = respiCalUId.data.iCalUId;
        console.log("response.data", response.data);
        
      } else {
        const olAppointmentService: IOutlookAppointmentService =
          baContainer.resolve(TokenIOutlookAppointmentService);
        const authenticationService: IAuthenticationService =
          baContainer.resolve(TokenIAuthenticationService);
        if (request.outlookUid) {
          const orgService: IOrganizationService = new OrganizationService();
          const respICalUid = await orgService.getICalUidExternal(
            response.data.tenantId,
            response.data.guid,
            request.outlookUid
          );
          response.data.iCalUIds = respICalUid.data;
          if (response.data.iCalUIds?.length) {
            let getMessageUrl = olAppointmentService.GetMessageUrl();
            getMessageUrl = getMessageUrl.replace(
              "?$select=iCalUId,originalStart",
              ""
            );
            const accessToken = await authenticationService.GetCallbackToken();
            const resp = await orgServiceImpl.getAppInfoByItemId(
              getMessageUrl,
              accessToken
            );
            if (resp) {
              const attendees: string[] = (resp.data.attendees || [])
                .map((item) => item.emailAddress?.address)
                .concat(
                  (resp.data.locations || [])
                    ?.map((item) => item.uniqueId)
                    .filter((email) => !!validateEmail(email))
                );
              const appointmentManager: IAppointmentManager =
                baContainer.resolve(TokenIAppointmentManager);
              appointmentManager.SaveDataResourceInfo(
                {
                  attendees: attendees,
                  startTime: resp.data.start?.dateTime,
                },
                "old_data_update"
              );
            }
          } else if(request.isRecurringMaster) {
            try {
              const appointmentManager: IAppointmentManager =
                baContainer.resolve(TokenIAppointmentManager);
              const newUid = await appointmentManager.CreateNewUid();
              console.log("newUid", newUid);
              response.data.uidOutlook = newUid;
            } catch (error) {
              console.log("error", error);
            }
          }
        }
      }
      return response.data;
    } else {
      return rejectWithValue(response.status || 400);
    }
  }
);

export const getCategorization: any = createAsyncThunk(
  "organization/get-categorization",
  async (data: {orgId: string; tenantId: string}, { rejectWithValue }) => {
    const orgServiceImpl: IOrganizationService = new OrganizationService();
    const response: HttpResponse<ICategorization> =
      await orgServiceImpl.fetchCategorization(data.tenantId, data.orgId);
    if (!response.error) {
      return response.data;
    } else {
      return rejectWithValue(response.errorMsg || "Error");
    }
  }
);

export const orgSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    updateOutlookInfo: (
      state: IOrganizationStore,
      action: PayloadAction<OutLookInfo>
    ) => {
      state.outlookInfo = action.payload;
    },
    updateOrgInfo: (
      state: IOrganizationStore,
      action: PayloadAction<OrganizationInfo>
    ) => {
      state.orgInfo = action.payload;
    },
    updateOrganizer: (
      state: IOrganizationStore,
      action: PayloadAction<Organizer>
    ) => {
      state.organizer = action.payload;
    },
    updateTimeOfOutlook: (
      state: IOrganizationStore,
      action: PayloadAction<DateTimePeriodDto>
    ) => {
      if (state.outlookInfo) {
        const outlookInfo = cloneDeep(state.outlookInfo);
        outlookInfo.start = action.payload.Start || null;
        outlookInfo.end = action.payload.End || null;
        outlookInfo.startTimeTicks = action.payload.StartTicks || null;
        outlookInfo.endTimeTicks = action.payload.EndTicks || null;
        outlookInfo.startTimeNotConvert =
          action.payload.StartTimeNotConvert || null;
        outlookInfo.endTimeNotConvert =
          action.payload.EndTimeNotConvert || null;
        outlookInfo.displayStartTime = action.payload.DisplayStartTime || null;
        outlookInfo.displayEndTime = action.payload.DisplayEndTime || null;
        state.outlookInfo = outlookInfo;
      }
    },

    updateRecurringOfOutlook: (
      state: IOrganizationStore,
      action: PayloadAction<OutlookAppointmentRecurrenceDto>
    ) => {
      if (state.outlookInfo) {
        const outlookInfo = cloneDeep(state.outlookInfo);
        outlookInfo.isRecurringMaster = !!action.payload.IsRecurringMaster;
        outlookInfo.occurrences = (action.payload.Occurrences || []).map(
          (item: DateTimePeriodDto) =>
            new DateTimePeriod({
              StartTicks: item.StartTicks,
              EndTicks: item.EndTicks,
              Start: item.Start,
              End: item.End,
            })
        );
        outlookInfo.start = action.payload?.Series.Start || null;
        outlookInfo.end = action.payload?.Series.End || null;
        outlookInfo.startTimeTicks = action.payload?.Series.StartTicks;
        outlookInfo.endTimeTicks = action.payload?.Series.EndTicks;
        if (
          action.payload?.Series?.DisplayStartTime &&
          action.payload?.Series?.DisplayEndTime
        ) {
          outlookInfo.displayStartTime =
            action.payload?.Series?.DisplayStartTime;
          outlookInfo.displayEndTime = action.payload?.Series?.DisplayEndTime;
        }
        if (
          action.payload?.Series?.StartTimeNotConvert &&
          action.payload?.Series?.EndTimeNotConvert
        ) {
          outlookInfo.startTimeNotConvert =
            action.payload?.Series?.StartTimeNotConvert;
          outlookInfo.endTimeNotConvert =
            action.payload?.Series?.EndTimeNotConvert;
        }
        state.outlookInfo = outlookInfo;
      }
    },
    updateLocationsAndCategory: (
      state: IOrganizationStore,
      action: PayloadAction<{
        locationTrees: ITreeInfo[];
        categoryTrees: ITreeInfo[];
        locationList: ICategorizationInfo[];
      }>
    ) => {
      state.categoryTrees = cloneDeep(action.payload.categoryTrees);
      state.locationTrees = cloneDeep(action.payload.locationTrees);
      state.locationList = cloneDeep(action.payload.locationList);
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IOrganizationStore>) => {
    builder
      .addCase(getOrgInfo.pending, (state: IOrganizationStore) => {
        state.loading = true;
      })
      .addCase(
        getOrgInfo.fulfilled,
        (
          state: IOrganizationStore,
          action: PayloadAction<OrganizationInfo>
        ) => {
          state.orgInfo = action.payload;
          state.loading = false;
        }
      )
      .addCase(getOrgInfo.rejected, (state: IOrganizationStore, action) => {
        state.errorCode = action.payload;
        state.loading = false;
      })
      .addCase(getCategorization.pending, (state: IOrganizationStore) => {
        state.loading = true;
      })
      .addCase(
        getCategorization.fulfilled,
        (
          state: IOrganizationStore,
          _action: PayloadAction<ICategorization>
        ) => {
          const locationTrees: ITreeInfo[] = [
            {
              guid: state.orgInfo?.tenantId || ROOT,
              name: TreeTypeEnum.Locations,
              iconKey: "",
              iconColor: "",
              isDefault: true,
              isFavorite: false,
              parentId: "",
              children: _action.payload.locations,
              isCollapsed: false,
              iconClosed: null,
              isDisabled: false,
            },
          ];
          const categoryTrees: ITreeInfo[] = [
            {
              guid: state.orgInfo?.tenantId || ROOT,
              name: TreeTypeEnum.Categories,
              iconKey: "",
              iconColor: "",
              isDefault: true,
              isFavorite: false,
              parentId: "",
              children: _action.payload.categories,
              isCollapsed: false,
              iconClosed: null,
              isDisabled: false,
            },
          ];
          state.locationTrees = locationTrees;
          state.categoryTrees = categoryTrees;
          const listLocation: ICategorizationInfo[] = convertTreeDataToArray(
            locationTrees,
            []
          );
          state.locationList = listLocation;
          state.loading = false;
        }
      )
      .addCase(getCategorization.rejected, (state: IOrganizationStore) => {
        state.loading = false;
      });
  },
});

export const {
  updateOutlookInfo,
  updateOrganizer,
  updateTimeOfOutlook,
  updateRecurringOfOutlook,
  updateOrgInfo,
  updateLocationsAndCategory,
} = orgSlice.actions;

export default orgSlice.reducer;
